export let clickForMoreLabel = "AMhQad";
export default {clickForMoreLabel};